var __TEMP__ = require('./_getNative.js');var getNative = __REQUIRE_DEFAULT__(__TEMP__);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = defineProperty;
